import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router'
import { CurrentUserService } from 'app/shared/services/current-user.service'
import { map, Observable, of } from 'rxjs'
import { EnumTypeUserAccountStatus } from './../../shared/generated/generated'
import { AppConfigService } from './../../shared/services/app-config.service'
import { PermissionService } from './../../shared/services/permission.service'

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  userIsAuthorized: boolean = false

  constructor(
    private currentlyAuthorizedUserService: CurrentUserService,
    private appConfigService: AppConfigService,
    private permissionService: PermissionService,
    private router: Router
  ) {
    this.currentlyAuthorizedUserService.isAuthorized$.subscribe((data) => {
      this.userIsAuthorized = data
      if (this.userIsAuthorized) {
        this.currentlyAuthorizedUserService.getCurrentlyAuthorizedUser().subscribe()
      }
    })
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.isAuthorized(null)
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.isAuthorized(childRoute)
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | UrlTree {
    return this.isAuthorized(route)
  }

  private isAuthorized(route: ActivatedRouteSnapshot) {
    if (this.userIsAuthorized) {
      if (route && route.data.role) {
        if (this.permissionService.doesUserHavePermission(route.data.role)) {
          return of(true)
        } else {
          return this.router.createUrlTree(['access-denied'])
        }
      } else {
        return of(true)
      }
    } else {
      return this.currentlyAuthorizedUserService.getCurrentlyAuthorizedUser().pipe(
        map((user) => {
          if (user == null) {
            window.location.href = this.appConfigService.getApiUrlWithEndpoint('api/Authentication/login')
          }

          if (user?.typeUserAccountStatusId == EnumTypeUserAccountStatus.Active) {
            return true
          }

          return this.router.createUrlTree(['auth/request-access'])
        })
      )
    }
  }
}
